import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import BackButton from "@Components/BackButton";
import Grid from "@Components/Grid";
import LoadingFullScreen from "@Components/Loading/LoadingFullScreen";
import { useGetDealer } from "@Hooks/useDealers";
import { useGetDealerFinance } from "@Hooks/useDealersDashboard";
import Applications from "@Pages/Applications";
import { DealerDashboardFilters } from "@Pages/DealersDashboard/DealersDashboard";

import useCurrentUser from "@Hooks/useCurrentUser";
import { hasSectionPermissions } from "@Utils/permissions";
import styles from "./Dealer.module.scss";
import DealerFinance from "./DealerFinance";
import DealerInfo from "./DealerInfo";
import DealerPerformanceChart from "./DealerPerformanceChart";
import Filters from "./Filters";

const Dealer = () => {
  const { id } = useParams<{ id: string }>();
  const user = useCurrentUser();
  const navigate = useNavigate();

  const { data: dealer, isLoading, error } = useGetDealer(id as string);

  const [filters, setFilters] = useState<DealerDashboardFilters>({
    county: "",
    state: "",
    year: undefined,
    month: undefined,
    basedOnLocationOf: "applicant",
    filterType: "all",
  });
  const { data: finance, isLoading: loadingFinance } = useGetDealerFinance(
    id as string,
    filters
  );

  const handleShowMap = () => navigate(`/dealers/map?id=${id}`);
  const hasAccessToFinance = hasSectionPermissions("deal", "financials", user);
  if (isLoading || loadingFinance) return <LoadingFullScreen />;
  if (error) return <>{error.message}</>;
  return dealer ? (
    <Grid container xs={12} spacing={1} className={styles.container}>
      <Grid xs={1.5}>
        <BackButton />
      </Grid>
      <Grid container xs={12}>
        <Grid xs={12}>
          <h2 className={styles.title}>
            {`Dealer: ${dealer?.data?.info?.displayName || "Dealer"}`}
          </h2>
        </Grid>

        <Grid
          container
          xs={12}
          alignItems="center"
          display="flex"
          direction={"row"}
        >
          <Grid flex={1}>
            <DealerInfo dealer={dealer} />
          </Grid>
          {hasAccessToFinance && (
            <Grid>
              <button className={styles.mapButton} onClick={handleShowMap}>
                <div className={styles.buttonText}>Show deals map</div>
              </button>{" "}
            </Grid>
          )}
        </Grid>
        {hasAccessToFinance && (
          <>
            <Grid xs={10}>
              <Filters setFilters={setFilters} filters={filters} />
            </Grid>
            <Grid xs={4}>
              <DealerFinance data={finance} />
            </Grid>
            <Grid xs={8}>
              <DealerPerformanceChart data={finance} />
            </Grid>
          </>
        )}
        <Grid xs={12}>
          <Applications dealerId={id} />
        </Grid>
      </Grid>
    </Grid>
  ) : null;
};

export default Dealer;
